import moment from 'moment';


/**
 * onChangeHelper :: (Array, Object) -> Boolean
 */
export const onChangeHelper = (selectType, selectedOptions, allOptions, onChange) => {
  const isIncludeAll = selectedOptions.includes(`${selectType}-select-all`);

  if (isIncludeAll && selectedOptions.length - 1 !== Object.values(allOptions).length) {
    return onChange(selectType, Object.values(allOptions).map(item => item._id));
  }

  if (isIncludeAll && (selectedOptions.length - 1 === Object.values(allOptions).length)) {
    return onChange(selectType, []);
  }
  return onChange(selectType, selectedOptions);
};

/**
 * isSelectedAll :: (Array, Object) -> Boolean
 */
export const isSelectedAll = (selectedOptions, allOptions) =>
  selectedOptions.length === Object.keys(allOptions).length ? 'Unselect all' : 'Select all';

/**
 * datePickerRanges - datePicker Options
 */
export const datePickerRanges = {
  'Last Month': [moment().subtract(1, 'month').startOf('month'),
    moment().subtract(1, 'month').endOf('month'),
  ],
  'Last Week': [moment().subtract(1, 'weeks').startOf('isoWeek'),
    moment().subtract(1, 'weeks').endOf('isoWeek'),
  ],
  Today: [moment().startOf('day'), moment()],
  'This Week': [moment().startOf('isoWeek'), moment()],
  'This Month': [moment().startOf('month'), moment()],
};



// WEBPACK FOOTER //
// ./src/utils/select.js